import { render, staticRenderFns } from "./GeneralRequests.vue?vue&type=template&id=ff3241fc&scoped=true&"
import script from "./GeneralRequests.vue?vue&type=script&lang=js&"
export * from "./GeneralRequests.vue?vue&type=script&lang=js&"
import style0 from "./GeneralRequests.vue?vue&type=style&index=0&id=ff3241fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3241fc",
  null
  
)

export default component.exports